// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLeaf3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.234 6.315a9.425 9.425 0 0 0-5.575 7.173c-.487 2.97-.035 6.343 2.67 8.455 3.872-2.688 9.004-3.34 11.716-6.586 2.798-3.353 2.283-7.972 2.42-12.652-3.26 1.546-7.01 1.752-11.231 3.61zm11.917-3.59c-.03.758-.03 1.53-.03 2.274-.028 4.015-.052 7.807-2.551 10.797-1.69 2.033-4.152 3.061-6.761 4.152-1.739.73-3.539 1.484-5.089 2.56l-.418.292-.398-.312c-1.446-1.145-3.785-3.85-2.92-9.117a10.08 10.08 0 0 1 5.972-7.68 36.598 36.598 0 0 1 6.247-2.009c1.772-.452 3.446-.874 4.971-1.597l1.012-.48z"
    />
    <path
      fill="currentColor"
      d="M9.035 15.123c-2.32 3.217-2.564 7.098-2.564 7.098a3.949 3.949 0 0 1-.772-.364c0-2.633 1.272-5.084 2.585-7.09 1.69-2.589 5.188-4.94 6.648-5.167 0 0-2.86 1.32-5.897 5.524z"
    />
  </svg>
);
export default SvgLeaf3;
